module.exports = __webpack_public_path__ + "static/media/help2.bbd84f31.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/help2.png
// module id = 1496
// module chunks = 10